import { instance } from "libs/api";

import { ApiRoutesAuth } from "./../../constants";
import { LoginRequest, LoginResponse } from "./login.types";

export const requestLogin = async (
  body: LoginRequest
): Promise<LoginResponse> => {
  return await instance.post(ApiRoutesAuth.Login, body);
};
